import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Reports_custom_ds_outbound_order_audit_report_headerService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { orderId?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, reportRecibidor?: string, reportSupervisor?: string, Account?: { Name?: string }, Project?: { LookupCode?: string }, ShipmentOrderLookups?: { ShipmentId?: number, Shipment?: { ShippedDate?: string, Tasks?: { Employee?: string }[] } }[], ShippedDate?: string, LoadingEmployee?: string } }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      orderId?: number    }) {
      return false;
    }
}
